import {
  CONVERT_MOBILE_HELP,
  HELP_QUESTIONS_CONVERT,
} from "./Components/constants";
import {
  Container,
  Grid,
  IconButton,
  Tab,
  Tabs,
  styled,
  useTheme,
  Box,
} from "@mui/material";
import {
  TRADE_HISTORY_TABS,
  TRADE_TYPES,
} from "pages/History/TradeHistory/constants";

import ConvertForm from "./Components/ConvertForm";
import { Help } from "assets/Icon";
import HelpBox from "components/HelpBox";
import { HelpContextWrapper } from "pages/BasicTrade";
import Modal from "components/Modal";
import TradeHistory from "pages/History/TradeHistory";
import useIsMobileView from "hooks/useIsMobileView";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { ROUTE_PATHS } from "routes/paths";

function Convert() {
  const convertTextToHTML = (text) => {
    return { __html: text };
  };

  const theme = useTheme();
  const navigate = useNavigate();
  const isMobileView = useIsMobileView();

  const [refreshHistory, setRefreshHistory] = useState(0);
  const [openModalHelp, setOpenModalHelp] = useState(false);

  return (
    <>
      <Container maxWidth="md">
        {isMobileView && (
          <Grid item xs={12} position="relative">
            <TabsStyle value="convert" aria-label="secondary tabs example">
              <Tab
                onClick={() => navigate(`${ROUTE_PATHS.trade.basic("1", "3")}?walletTypeId=1`)}
                label="Spot"
              />

              <Tab
                label="Margin"
                onClick={() => navigate(`${ROUTE_PATHS.trade.basic("1", "3")}?walletTypeId=2`)}
              />

              <Tab label="Convert" value="convert" />
            </TabsStyle>

            <IconButtonStyle
              color="text"
              onClick={() => setOpenModalHelp(true)}
            >
              <Help color={theme.palette.text.main} />
            </IconButtonStyle>
          </Grid>
        )}

        <Grid container spacing={1} mt={5}>
          <Grid item xs={12} md={7}>
            <ConvertForm setRefreshHistory={setRefreshHistory} />
          </Grid>

          {!isMobileView && (
            <Grid item xs={12} md={5}>
              <Box marginLeft={3}>
                <HelpBox
                  questions={HELP_QUESTIONS_CONVERT}
                  title="راهنما و سوالات متداول"
                />
              </Box>
            </Grid>
          )}

          <Modal
            title={CONVERT_MOBILE_HELP?.title}
            maxWidth="xs"
            dir="rtl"
            open={openModalHelp}
            onClose={() => setOpenModalHelp(false)}
          >
            <HelpContextWrapper
              dir="rtl"
              dangerouslySetInnerHTML={convertTextToHTML(
                CONVERT_MOBILE_HELP?.description
              )}
            ></HelpContextWrapper>
          </Modal>
        </Grid>
      </Container>

      <Box container id="convert_history">
        <TradeHistory
          key={refreshHistory}
          defaultFilters={{ convert: TRADE_TYPES.convert }}
          hideTab
          defaultTradeTab={TRADE_HISTORY_TABS.tradeHistory.value}
        />
      </Box>
    </>
  );
}

const TabsStyle = styled(Tabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.modules.border}`,

  ".MuiButtonBase-root": {
    marginRight: theme.spacing(1),
  },
}));

const IconButtonStyle = styled(IconButton)(() => ({
  position: "absolute",
  right: 0,
  bottom: 0,
}));

export default Convert;
